import React, {useEffect, useState} from 'react'

import styles from '../styles.module.css'

interface Props {
  accessToken: string
  orderId: string
}

const OrderDetails: React.FC<Props> = ({accessToken, orderId}) => {
  const [orderSelected, setOrderSelected] = useState<any>()

  useEffect(() => {
    const requestOptions = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: accessToken
      }
    }

    fetch(
      `https://poc-micro-service.herokuapp.com/order/detail/${orderId}`,
      requestOptions
    )
      .then((res) => res.json())
      .then(
        (result) => {
          console.log(orderSelected)
          setOrderSelected(result)
        },
        (error) => {
          console.log(error)
        }
      )
  }, [])

  return (
    <div className={styles.test}>
      <h1>Ordem selecionada (Lib react)</h1>
      {orderSelected && <h5>{orderSelected.uuid}</h5>}
      {orderSelected?.detail.map((detail: any) => (
        <div key={detail.item}>
          <p>Item: {detail.item}</p>
          <p>Cód.: {detail.product_code}</p>
          <p>Produto: {detail.product_name}</p>
          <p>Valor: {detail.value}</p>
        </div>
      ))}
    </div>
  )
}

export default OrderDetails
